import { Component, OnInit, HostListener } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { ToastrService } from 'ngx-toastr';
import { CommonDataService } from '../../../app/providers/common-data.service';
import { Helper_Class } from '../../../app/helper_class';
import { ipaddress } from '../../ipaddress';
import { Message_data } from 'src/assets/js/Message_data';
@Component({
  selector: 'app-phrama-supplier-product-mst',
  templateUrl: './phrama-supplier-product-mst.component.html',
  styleUrls: ['./phrama-supplier-product-mst.component.scss']
})
export class PhramaSupplierProductMstComponent implements OnInit {
  public supplierList: any = [];
  public hsn_no: string = "";
  public shortName: string = "";
  public genericName: string = "";
  public productName: string;
  public productTypeID;
  public costPrice: any;
  public sellingPrice: any;
  public MRP: any = "";
  public prodGST: any;
  public prodDiscount;
  public product: any = [];
  public pharmacyID;
  public PharmauserID;
  public index = this.product.length;
  public productMasterAddArray = [];
  public productMasterIndex = 0;
  public pageNavigate: boolean;
  public prevPageCount: boolean;
  public nextPageCount: boolean;
  public newFlag: boolean;
  public existFlag: boolean;
  public prodType;
  public currentPage;
  public prodDataCount;
  public pagelist;
  public pageSize;
  public noOfPages: any
  public userInfo;
  public suppID;
  public getProductID = [];
  public saveFlag: boolean = true;

  constructor(public gservice: CommonDataService, public http: Http, public toastr: ToastrService) {
    this.pageNavigate = true;
    this.pagelist = "50";
    this.currentPage = 0;
    this.pageSize = 50;
    this.newFlag = false;
    this.existFlag = true;
  }

  ngOnInit(): void {
    this.userInfo = Helper_Class.getInfo();
    this.PharmauserID = this.userInfo.user_id;
    for (var i = 0; i < this.userInfo.hospitals.length; i++) {
      this.pharmacyID = this.userInfo.hospitals[0].hptl_clinic_id;
    }
    this.getSuppliers();
    this.getProductCount();
  }

  getSuppliers() {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp + "pharmacontrol/gsup/",
      JSON.stringify({
        pharmacy_id: this.pharmacyID,
      }), { headers: headers }).subscribe(
        data => {
          this.supplierList = [];
          if (data.json().supplier_details != null && data.json().supplier_details.length != 0) {
            this.supplierList = data.json().supplier_details;
            this.suppID = data.json().supplier_details[0].supp_id;
            this.getProductCount();
            //this.getSuppliersProduct();
          }
        },
        error => {
          this.toastr.error(Message_data.unableToFetchDocDet);
        }
      )
  }

  // getSuppliersProduct() {
  //   this.getProductID=[];
  //   var headers = new Headers();
  //   headers.append('Content-Type', 'application/json');
  //   this.http.post(ipaddress.getIp + "pharmacontrol/gps",
  //     JSON.stringify({
  //       pharmacy_id: this.pharmacyID,
  //       supp_id: this.suppID
  //     }), { headers: headers }).subscribe(
  //       data => {
  //         var obj = data.json();
  //         if (obj.products.length != 0) {
  //           this.getProductID = obj.products;
  //           //this.retrieveProduct();
  //         } 
  //       },
  //       error => {
  //         this.toastr.error(Message_data.unableToFetchDocDet);
  //       }
  //     )
  // }

  getProductCount() {
    this.productMasterAddArray = [];
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp.toString() + 'pharmacontrol/gcount',
      JSON.stringify({
        pharma_id: this.pharmacyID,
        supp_id: this.suppID
      }),
      { headers: headers })
      .subscribe(
        response => {
          var obj = JSON.parse(response["_body"]);
          if (obj.product_count > 50) {
            this.pageNavigate = false;
          } else {
            this.pageNavigate = true;
          }
          this.prodDataCount = obj.product_count;
          this.retrieveProduct()
        },
        error => {
        }
      )
  }

  retrieveProduct() {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp + "pharmacontrol/gpcbyphar",
      JSON.stringify({
        pharmacist_id: this.PharmauserID,
        pharmacy_id: this.pharmacyID,
        imei: Helper_Class.getIPAddress(),
        limit: this.pageSize,
        start_no: this.currentPage,
        supp_id: this.suppID
      }),
      { headers: headers }).subscribe(
        data => {
          var obj = data.json();
          if (obj != null && obj.products != null) {
            console.log("PRODUCTS "+JSON.stringify(obj))
            this.productMasterAddArray = [];
            for (var i = 0; i < obj.products.length; i++) {
              var checked;
              const index = this.getProductID.indexOf(obj.products[i].product_id);
              if (index !== -1) {
                checked = true;
              } else {
                checked = false;
              }
              this.productMasterAddArray.push({
                Index: this.productMasterIndex,
                hsn_no: obj.products[i].hsn_no,
                name: obj.products[i].name,
                short_name: obj.products[i].short_name,
                generic_name: obj.products[i].generic_name,
                medicare_id: obj.products[i].medicare_id,
                medicare_name: obj.products[i].medicare_name,
                product_type_id: obj.products[i].product_type_id,
                product_type_desc: obj.products[i].product_type_desc,
                category_type_id: obj.products[i].category_type_id,
                category_name: obj.products[i].category_name,
                uom_code: obj.products[i].uom_code,
                uom_desc: obj.products[i].uom_desc,
                mfg_id: obj.products[i].mfg_id,
                mfg_name: obj.products[i].mfg_name,
                product_id: obj.products[i].product_id,
                pharmacist_id: this.PharmauserID.toString(),
                per_unit: obj.products[i].per_unit,
                cost_price: obj.products[i].cost_price,
                sales_price: obj.products[i].sales_price,
                MRP: obj.products[i].MRP,
                prod_gst: obj.products[i].prod_gst,
                prod_disc: obj.products[i].prod_disc,
                supp_id: obj.products[i].supp_id,
                supp_name: obj.products[i].name,
                checked: checked
              });
            }
          }
        },
        error => {
        }
      )
  }

  

  pagelistChange() {
    this.pageSize = this.pagelist;
    this.currentPage = 1;
    this.getProductCount();
    if (this.pagelist == "50") {
      if (this.prodDataCount > 50) {
        this.pageNavigate = false;
        this.nextPageCount = false;
        this.prevPageCount = false;
      } else {
        this.pageNavigate = true;
        this.nextPageCount = true;
        this.prevPageCount = true;
      }
    } else if (this.pagelist == "100") {
      if (this.prodDataCount > 100) {
        this.pageNavigate = false;
        this.nextPageCount = false;
        this.prevPageCount = false;
      } else {
        this.pageNavigate = true;
        this.nextPageCount = true;
        this.prevPageCount = true;
      }
    } else if (this.pagelist == "200") {
      if (this.prodDataCount > 200) {
        this.pageNavigate = false;
        this.nextPageCount = false;
        this.prevPageCount = false;
      } else {
        this.pageNavigate = true;
        this.nextPageCount = true;
        this.prevPageCount = true;
      }
    }
    this.retrieveProduct();
  }

  pageLimitnext() {
    this.currentPage = this.currentPage + 1;
    this.pageSize = this.pagelist;
    this.getProductCount();
    this.retrieveProduct();
    this.prevPageCount = false;
    if (this.currentPage == this.noOfPages) {
      this.nextPageCount = true;
    }
  }

  pageLimitPrevious() {
    this.pageSize = this.pagelist;
    if (this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
      this.getProductCount();
      this.retrieveProduct();
      this.nextPageCount = false;
      if (this.currentPage == "1") {
        this.prevPageCount = true;
      }
    } else {
      this.prevPageCount = true;
    }
  }

  numberOfPages() {
    this.noOfPages = Math.ceil(this.prodDataCount / this.pagelist);
    return Math.ceil(this.prodDataCount / this.pagelist);
  }

  product_filter() {
    if (this.productName !== "" && this.productName.length > 2) {
      this.pageNavigate = true;
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      this.http.post(ipaddress.getIp.toString() + 'pharmacontrol/prodByName/',
        JSON.stringify({
          prod_name: this.productName,
          pharmacy_id: this.pharmacyID,
        }),
        { headers: headers })
        .subscribe(
          response => {
            this.productMasterAddArray = [];
            var obj = JSON.parse(response["_body"]);
            if (obj.products != null) {
              this.productMasterAddArray = [];
              this.pagelist = "50";
              this.pageNavigate = false;
              for (var i = 0; i < obj.products.length; i++) {
                this.productMasterAddArray.push({
                  Index: this.productMasterIndex,
                  hsn_no: obj.products[i].hsn_no,
                  name: obj.products[i].name,
                  short_name: obj.products[i].short_name,
                  generic_name: obj.products[i].generic_name,
                  medicare_id: obj.products[i].medicare_id,
                  medicare_name: obj.products[i].medicare_name,
                  product_type_id: obj.products[i].product_type_id,
                  product_type_desc: obj.products[i].product_type_desc,
                  category_type_id: obj.products[i].category_type_id,
                  category_name: obj.products[i].category_name,
                  uom_code: obj.products[i].uom_code,
                  uom_desc: obj.products[i].uom_desc,
                  mfg_id: obj.products[i].mfg_id,
                  mfg_name: obj.products[i].mfg_name,
                  product_id: obj.products[i].product_id,
                  pharmacist_id: this.PharmauserID.toString(),
                  per_unit: obj.products[i].per_unit,
                  cost_price: obj.products[i].cost_price,
                  sales_price: obj.products[i].sales_price,
                  MRP: obj.products[i].MRP,
                  prod_gst: obj.products[i].prod_gst,
                  prod_disc: obj.products[i].prod_disc,
                });
                this.productMasterIndex++;
              }
            } else {
              this.toastr.error(Message_data.noPrd);
            }
          },
          error => {
          }
        )
    } else {
      this.pageNavigate = false;
      this.pagelist = "50";
    }
  }

  isAllSelected(id,checked) {
    if(checked == false){
      const index = this.getProductID.indexOf(id);
      if(index != -1){
        this.getProductID.splice(index, 1);
      }
      
    } else {
      this.getProductID.push(id);
    }
    
    var check = this.getProductID;
  }

  suppler_masterclick() {
    if (this.getProductID.length == 0) {
      this.toastr.error(Message_data.selectOnePrd);
    } else if (this.suppID == "" || this.suppID == undefined || this.suppID == null) {
      this.toastr.error(Message_data.suppORdistributor);
    } else {
      //this.saveFlag = false;
      var send_data = {
        pharma_id: this.pharmacyID,
        supp_id: this.suppID,
        product_id: this.getProductID,
      }
      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      this.http.post(ipaddress.getIp.toString() + 'pharmacontrol/sps', send_data,
        { headers: headers })
        .subscribe(
          response => {
            var obj = response.json();
            if (obj.key == "1") {
              this.toastr.success(Message_data.prdUpdSuccess);
            } else {
            }
          },
          error => { 
            
          });
    }
  }
}
